import React from 'react';
import { useNavigate } from 'react-router-dom';
import Calendar from '../components/Calendar';
import { useMissionContext } from '../context/MissionContext';

export default function CalendarPage() {
  const { missions } = useMissionContext();
  const navigate = useNavigate();

  const goMission = (mission) => {
    navigate('/mission/' + encodeURIComponent(mission.id));
  };

  return (
    <>
      <h1 className="page-title">Calendrier</h1>
      <Calendar missions={missions} onMissionClick={goMission} />
    </>
  );
}
